export function isAuthenticated(state) {
  return state.isAuthenticated
}
